module.exports = __webpack_public_path__ + "static/img/200163.3d432644.png";